import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { ReturnMessageModel } from '../shared/model/return-message.model';
import { MessageComponent } from '../shared/component/message/message.component';
import { ListValueModalComponent } from '../shared/component/list-value-modal/list-value-modal.component';

import { DynamicListModel } from '../shared/model/dynamic-list.model';
import { DynamicListService } from '../shared/service/dynamic-list.service';
import { DynamicListItemModel } from '../shared/model/dynamic-list-item.model';
import { DynamicListFieldResponseService } from '../shared/service/dynamic-list-response.service';
import { DynamicListFieldRawResponseModel } from '../shared/model/dynamic-list-field-raw-response.model';

@Component({
  styles: [''],
  selector: 'app-dynamic-list-item',
  templateUrl: './dynamic-list-item.component.html',
})
export class DynamicListItemComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ListValueModalComponent) modal: ListValueModalComponent;

  getAll = { init: 0, end: 1e8 };

  groupedCount: number;
  dynListsRecords: number;

  allRawFields: any[] = [];
  allOptionFields: any[] = [];

  dynListOptions: any[] = [];
  dynPrimaryFieldOptions: any = {};

  dynLists: DynamicListModel[] = [];
  dynPrimaryFields: DynamicListFieldRawResponseModel[] = [];

  groupedResponses: any[] = [] as any[];

  // SELECTION AND ORDENATION

  selectionList: any = {};
  selectionFieldRawResponse: any = {};

  selectionFields = [];
  selectionFieldOptions = [];
  selectionFieldRawOptions = [];

  selectedMethod = '';
  selectedOrdenation = '';

  ascDesc = [];
  ordenation = [];

  constructor (
    private translService: TranslateService,
    private dynListService: DynamicListService,
    private dynRespService: DynamicListFieldResponseService,
  ) {}

  ngOnInit() {
    // this.loadDynamicLists();
    this.loadAllFields();
    // this.loadResponses();
    this.onNewField();
  }

  lazyList({ first: init, rows: end }) {
    this.loadDynamicLists({ init, end });
  }

  lazyField({ first: init, rows: end, filters }) {
    const list_value = filters['values'] && filters['values'].value;
    const list_name = filters['list'] && filters['list'].value;

    this.loadResponses({ init, end, list_name, list_value });
  }

  loadResponses(query?) {
    this.dynRespService.getAllRawResponsesGrouped(query).subscribe(({ rows, count }) => {
      this.groupedResponses = rows.map((v: DynamicListItemModel | any) => {
        v.name =  this.getListNameById(v.dyn_list_id);
        return v as DynamicListItemModel;
      })

      this.groupedCount = count || this.groupedResponses.length;

      this.loadPrimaryFieldRawResponses();
      this.loadOrdenation();
    });
  }

  loadPrimaryFieldRawResponses() {
    this.dynRespService.getAllRawResponses({ ...this.getAll, only_primary: true } as any).subscribe(({ rows }) => {
      this.dynPrimaryFields = rows as DynamicListFieldRawResponseModel[];

      this.filterPrimaryOptions();
    });
  }

  loadDynamicLists(query?) {
    this.dynListService.getPaginated(query || this.getAll)
    .subscribe(({ count: count, rows: dynamicLists }) => {
      this.dynLists = dynamicLists as DynamicListModel[];
      this.dynListsRecords = count;

      this.dynListOptions = dynamicLists.map(
      ({ name: label, id: value }) => {
        return { label, value }
      });
    });
  }

  loadAllFields() {
    this.dynListService.getPaginatedFieldRaw(this.getAll).subscribe(
      ({ rows }) => this.allRawFields = rows
    );

    this.dynListService.getPaginatedFieldOptions(this.getAll).subscribe(
      ({ rows }) => this.allOptionFields = rows
    );
  }

  clearSelection() {
    this.selectionFields = [];
    this.selectionFieldOptions = [];
    this.selectionFieldRawOptions = [];
  }

  filterPrimaryOptions() {
    this.dynPrimaryFieldOptions = {};

    this.dynPrimaryFields.forEach(({ dyn_list_item, value: label, id: value }) => {
      if (!this.dynPrimaryFieldOptions[dyn_list_item.dyn_list_id])
      this.dynPrimaryFieldOptions[dyn_list_item.dyn_list_id] = [];

      this.dynPrimaryFieldOptions[dyn_list_item.dyn_list_id].push({ label, value })
    });
  }

  loadFieldsByFieldSelection() {
    this.clearSelection();

    const { id: dyn_list_item_id, dyn_list_id } = this.selectionFieldRawResponse;
    const target = this.groupedResponses.find(v => v.id == dyn_list_item_id);
    const { dyn_list_field_raw_resp, dyn_list_field_options_resp } = target;

    if (dyn_list_field_raw_resp && dyn_list_field_raw_resp.length)
    dyn_list_field_raw_resp.forEach(({ id, value, dyn_list_field_raw_id, dyn_list_field_raw }) => {
      const label = dyn_list_field_raw && dyn_list_field_raw.name || 'N/A';

      this.selectionFieldRawOptions.push({ label, value: dyn_list_field_raw_id });

      this.selectionFields.push(new DynamicListFieldRawResponseModel({
        dyn_list_field_raw_id,
        dyn_list_item_id,
        value, label, id,
        dyn_list_id,
      } as any))
    })

    if (dyn_list_field_options_resp && dyn_list_field_options_resp.length) {
        dyn_list_field_options_resp.forEach((option: any) => {
          const { id: dyn_list_item_id } = this.selectionFieldRawResponse;
          const { id: value, dyn_list_resp_raw_id, dyn_list_field_option } = option;
          const { dyn_list_id, list_resp_type_id, id: dyn_list_field_option_id, name: label } = dyn_list_field_option;

          this.selectionFieldOptions.push({
            dyn_list_field_option_id,
            dyn_list_resp_raw_id,
            list_resp_type_id,
            dyn_list_item_id,
            value, label,
            dyn_list_id,
            id: value
          });
        }
      );
    }
  }
  
  loadFieldsByListSelection() {
    this.clearSelection();

    if (this.selectionFieldRawResponse.dyn_list_id)
    this.dynListService.findByPk(this.selectionFieldRawResponse.dyn_list_id).subscribe((list) => {
      const { dyn_list_field_raw, dyn_list_field_options } = list;

      if (dyn_list_field_raw && dyn_list_field_raw.length)
      dyn_list_field_raw.forEach(({ name: label, id: value }) => {
        this.selectionFieldRawOptions.push({ label, value });

        this.selectionFields.push(new DynamicListFieldRawResponseModel({
          dyn_list_id: this.selectionFieldRawResponse.dyn_list_id,
          dyn_list_field_raw_id: value,
        } as any))
      })

      if (dyn_list_field_options && dyn_list_field_options.length) {
          dyn_list_field_options.forEach((option) => {
            const { id: value, name: label, list_resp_type_id, dyn_list_id } = option;
            const { id: dyn_list_item_id } = this.selectionFieldRawResponse;

            this.selectionFieldOptions.push({
              dyn_list_field_option_id: value,
              // dyn_list_resp_raw_id
              list_resp_type_id,
              dyn_list_item_id,
              value, label,
              dyn_list_id,
            });
          }
        );
      }
    })
  }

  loadNewFields() {
    const { id: dyn_list_item_id } = this.selectionFieldRawResponse;

    if (this.selectionFieldRawResponse.dyn_list_id)
    this.dynListService.findByPk(this.selectionFieldRawResponse.dyn_list_id).subscribe((list) => {
      const { dyn_list_field_raw, dyn_list_field_options } = list;

      if (dyn_list_field_raw && dyn_list_field_raw.length)
      dyn_list_field_raw.forEach(({ name: label, id: value }) => {
        if (
          this.selectionFieldRawOptions.findIndex((v) => 
            v && v.label == label && v.value == value
          ) == -1
        ) this.selectionFieldRawOptions.push({ label, value });

        if (
          this.selectionFields.findIndex(({ dyn_list_id, dyn_list_field_raw_id }) =>
            dyn_list_id && dyn_list_id == this.selectionFieldRawResponse.dyn_list_id &&
            dyn_list_field_raw_id && dyn_list_field_raw_id == value
          ) == -1
        ) {
          this.selectionFields.push(new DynamicListFieldRawResponseModel({
            dyn_list_id: this.selectionFieldRawResponse.dyn_list_id,
            dyn_list_field_raw_id: value,
            dyn_list_item_id
          } as any))
        }
      })

      if (dyn_list_field_options && dyn_list_field_options.length) {
          dyn_list_field_options.forEach((option) => {
            const { id: value, name: label, list_resp_type_id, dyn_list_id } = option;
            const { id: dyn_list_item_id } = this.selectionFieldRawResponse;

            if (
              this.selectionFieldOptions.findIndex((v) => v &&
                v.list_resp_type_id == list_resp_type_id &&
                // v.dyn_list_item_id == dyn_list_item_id &&
                v.dyn_list_field_option_id == value &&
                v.dyn_list_id == dyn_list_id
              ) == -1
            ) {
              this.selectionFieldOptions.push({
                dyn_list_field_option_id: value,
                // dyn_list_resp_raw_id
                list_resp_type_id,
                dyn_list_item_id,
                value, label,
                dyn_list_id,
              });
            }
          }
        );
      }
    })
  }

  fillExistentValues() {
    if (
      this.selectionFieldRawResponse.dyn_list_field_raw_resp &&
      this.selectionFieldRawResponse.dyn_list_field_raw_resp.length
    ) {
      this.selectionFieldRawResponse.dyn_list_field_raw_resp.forEach((response) => {
        const { id, value, dyn_list_field_raw_id, dyn_list_item_id } = response;

        this.selectionFields.forEach((selection, i: number) => {
          if (selection.dyn_list_field_raw_id == dyn_list_field_raw_id) {
            this.selectionFields[i].dyn_list_item_id = dyn_list_item_id;
            this.selectionFields[i].value = value;
            this.selectionFields[i].id = id;
          } 
          // else console.error('Error field filling');
        });
      })
    }
  }

  getListNameById(id: number) {
    const res = this.dynLists.find(v => v.id == id);
    return res && res.name || 'N/A';
  }

  getFieldNameById(id: number) {
    const res = this.allRawFields.find(v => v.id == id);
    return res && res.name || 'N/A';
  }

  getOptionNameById(id: number) {
    const res = this.allOptionFields.find(v => v.id == id);
    return res && res.name || 'N/A';
  }

  getFieldAndValues(item) {
    const { dyn_list_field_raw_resp } = item;

    if (dyn_list_field_raw_resp && dyn_list_field_raw_resp.length) {
      return dyn_list_field_raw_resp.map(({ dyn_list_field_raw_id, value }) => {
        return ` ${this.getFieldNameById(dyn_list_field_raw_id)}: ${value}`;
      })
    } else return this.translate('empty_message');
  }

  onSelectList({ data }) {
    this.selectionFieldRawResponse.dyn_list_id = data.id as number;
    this.selectionFieldRawResponse.id = data.id as number;
    this.selectionList = data as DynamicListModel;

    this.loadFieldsByListSelection();

    // auto filter items by selected list - Emanuel request
    this.loadResponses({ dyn_list_id: this.selectionList && this.selectionList.id });
  }

  onSelectField({ data }) {
    this.selectionFieldRawResponse = data as DynamicListFieldRawResponseModel;

    this.loadFieldsByFieldSelection();
    this.fillExistentValues();
    this.loadNewFields();
  }

  onNewField() {
    this.selectionFieldRawResponse = new DynamicListFieldRawResponseModel({
      dyn_list_id: this.selectionFieldRawResponse.dyn_list_id
    } as DynamicListFieldRawResponseModel);

    this.selectionFieldOptions.forEach((field, i: number) => {
      if (field && field.value) {
        this.selectionFieldOptions[i].dyn_list_resp_raw_id = null;
        this.selectionFieldOptions[i].value = null;
      }
    })

    this.selectionFields.forEach((field, i: number) => {
      if (field && field.value) {
        this.selectionFields[i].value = null;
        this.selectionFields[i].id = null;
      }
    })
  }

  onSaveField() {
    if (!this.selectionFieldRawResponse.dyn_list_id) return this.message.error(this.translate('list_not_selected'));

    this.dynRespService.saveFieldRawResponse(this.selectionFields)
    .subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message);
      else this.message.success(r.message);

      if (this.selectionFieldOptions && this.selectionFieldOptions.length)
      this.dynRespService
      .saveFieldOptionResponse(this.selectionFieldOptions)
      .subscribe(_ => this.loadResponses());
      else
      this.loadResponses();
      this.onNewField();
    });
  }

  onDeleteField() {
    if (!this.selectionFieldRawResponse.dyn_list_id) return this.message.error(this.translate('field_not_selected'));

    this.dynRespService.deleteField(this.selectionFieldRawResponse).subscribe(res => {
      if (!res || res && res.error) this.message.error(this.translate('error'));
      else this.message.success(this.translate('success'));

      this.onNewField();
      this.loadResponses();
    });
  }

  // Aux Functions

  loadOrdenation() {
    this.ascDesc = [
      { value: 'asc', label: this.translate('asc') },
      { value: 'desc', label: this.translate('desc') },
    ];

    this.ordenation = [
      { value: 'name', label: this.translate('alph_order') },
      { value: 'id', label: this.translate('creation_date') }
    ];
  }

  validate(): boolean {
    return this.selectionFields.filter(({value}) => !!value).length == this.selectionFields.length;
  }

  order() {
		this.dynLists = _.orderBy(this.dynLists, this.selectedOrdenation, this.selectedMethod);
		this.groupedResponses = _.orderBy(this.groupedResponses, this.selectedOrdenation, this.selectedMethod);
  }

  translate = (key: string) => this.translService.instant(key || "invalid");
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/dynamic-list-item/dynamic-list-item.component.ts